/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const GeneralFeedbackExtraParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('general-feedback')],
]);
export class GeneralFeedbackExtra extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return GeneralFeedbackExtraParser.decode(input).map(res => new GeneralFeedbackExtra(res));
    }
    static unsafeDecode(input) {
        return GeneralFeedbackExtra.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return GeneralFeedbackExtraParser.encode(data);
    }
    static schema() {
        return GeneralFeedbackExtraParser.schema();
    }
}
